<template>
    <v-app>
        <v-main>
            <Buscador :field_tipos_documentales="'tipos_documentales'"/>
        </v-main>
    </v-app>
</template>
<script>
import Buscador from '../components/buscador/Buscador.vue'
export default {
    components: {
        Buscador
    },
    data(){
        return {

        }
    },
    created(){
        
    }
}
</script>